<template>

    <v-scale-transition>
        <v-card v-show="reward.enabled"
                hover
                color="grey darken-2"
                :max-height="cardHeight"
                :max-width="900"
                :min-height="cardHeight">

            <v-card-text class="pa-0">

                <div class="d-flex">

                    <!-- REWARD IMAGE -->
                    <v-img contain width="125" height="80" class="elevation-2" :src="reward.meta_data.image_urls['300w-326ppi']"></v-img>

                    <!-- REWARD TEXT AND INFO BUTTON -->
                    <v-card class="d-flex justify-space-between" flat color="transparent" height="80" width="100%">

                            <div class="ml-4 align-self-center">
                                <h3>{{ reward.name }}</h3>
                            </div>

                            <div class="ml-10 align-self-center">
                                <v-btn text @click="infoClicked">
                                    <v-icon left>mdi-information-outline</v-icon>
                                    Info
                                </v-btn>
                            </div>

                    </v-card>

                    <!-- REWARD COST -->
                    <v-card color="primary" class="align-self-center pa-1 pl-3 pr-3 subtitle-1 font-weight-medium text-no-wrap">
                        {{ reward.cost.toLocaleString() }} {{ reward.cost_currency }}
                    </v-card>

                    <!-- DELETE BUTTON -->
                    <div class="align-self-center ml-3 mr-3">
                        <v-tooltip color="primary" right>
                            <template v-slot:activator="{ on }">
                                <v-btn @click="disableClicked" :loading="removing" class="elevation-1" icon small color="grey lighten-2"
                                       v-on="on">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Remove this card</span>
                        </v-tooltip>
                    </div>
                </div>

            </v-card-text>

            <tango-card-info-dialog v-model="infoDialogModel"
                                    :key="reward.id"
                                    :name="reward.meta_data.reward_name"
                                    :description="reward.meta_data.description"
                                    :disclaimer="reward.meta_data.disclaimer"
                                    :terms="reward.meta_data.terms"
                                    :redemption-instructions="reward.meta_data.redemptionInstructions"
            ></tango-card-info-dialog>

            <confirmation-dialog v-model="disableConfirmationDialogModel" headline="Are you sure?"
                                 :description="disableDescription"
                                 @selected="disableDo"
            ></confirmation-dialog>

        </v-card>
    </v-scale-transition>

</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapActions} from 'vuex';
import TangoCardInfoDialog from "./TangoCardInfoDialog";
import ConfirmationDialog from "../../../../components/UI/ConfirmationDialog";

const vuexModule = 'Rewards';

export default {

    components: {
        Json,
        TangoCardInfoDialog,
        ConfirmationDialog
    },

    props: {
        reward: {
            type: Object,
            required: true,
        }
    },

    computed: {
        ...mapState(vuexModule, []),
    },

    data() {
        return {
            cardHeight: 80,
            infoDialogModel: false,
            disableConfirmationDialogModel: false,
            removing: false,
            disableDescription: "Are you sure you want to disable this reward? When disabled the reward disappears from available rewards " +
                "and cannot be redeemed anymore. " +
                "You can add this reward back by simply selecting it again from the catalog."
        }
    },

    methods: {
        ...mapActions(vuexModule, [
            'removeReward'
        ]),

        filterLinks(html) {
            if (!html) return '';
            return html.replace(/<a\b[^>]*>/ig, "").replace(/<\/a>/ig, "");
        },

        infoClicked() {
            this.infoDialogModel = true;
        },

        disableClicked() {
            this.disableConfirmationDialogModel = true;
        },

        disableDo(confirm) {

            if (!confirm) return;

            this.removing = true;

            this.removeReward(this.reward.id)
                .then((response) => {
                    Bus.$emit("flash-message", {message: "Reward disabled!"});
                })
                .catch((error) => {
                    console.log(error);
                    Bus.$emit("flash-message", {type: 'error', message: "OOPS Reward failed to delete!"});
                })
                .finally(() => {
                    this.removing = false;
                })
        }
    }
}
</script>
